import styled from 'styled-components'
import Text from '../atoms/Text'

const Wrapper = styled.div`
  display: flex; 
  flex-direction: column;
  text-align: center;
`
const TextBlock = styled(Text)`
  padding: 4px 2px;
  background-color: ${(props) => props.theme.colors.neutral[200]};
  border-radius: 4px;
  border: 1px solid
    ${({ $isActive, theme }) =>
      $isActive ? theme.colors.primary : "none"};
  cursor: ${({ $isEditable }) => ($isEditable ? 'pointer' : 'default')};
  pointer-events: ${({ $isEditable }) => ($isEditable ? 'auto' : 'none')};
  `
const WordBlock = ({ $isEditable, word, onToggle, selectedMeaning, $isActive }) => {
  // console.log($isEditable)
  return (
    <Wrapper $isEditable={$isEditable}>
      <TextBlock $isEditable={$isEditable} onClick={onToggle} $isActive={$isActive}>{word.content}</TextBlock>
      {selectedMeaning && <Text variant="caption">{selectedMeaning}</Text>}
    </Wrapper>
  )
}

export default WordBlock
